import script from "./PlatformCode.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformCode.vue?vue&type=script&setup=true&lang=js"

import "./PlatformCode.vue?vue&type=style&index=0&id=4afe488a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4afe488a"]])

export default __exports__